import awsIAMUsers from './awsIAMUsers';

export default awsIAMUsers;
